import script from "./TypingDots.vue?vue&type=script&setup=true&lang=js"
export * from "./TypingDots.vue?vue&type=script&setup=true&lang=js"

import "./TypingDots.vue?vue&type=style&index=0&id=21da145b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21da145b"]])

export default __exports__